import * as React from 'react';

import type FieldReportTypeSidePanelVM from 'ab-viewModels/fieldReport/fieldReportTypeSidePanel.viewModel';

import ImagePreviewModal from 'af-components/ImagePreviewModal';

import FieldReportTypeSidePanelModal from '../SidePanel/FieldReportTypeModal';
import styles from '../styles.module.scss';

type SegmentCount = { [instanceIndex: number]: number; };
type Props = {
	headerValue: string;
	openFieldReportTypeModal: () => void;
	fieldReportTypeToPreview: Nullable<FieldReportTypeSidePanelVM>;
	onImageClick: (imageSrc: string) => void;
	onExportAsPDFClick: (fieldReportTypeIds: number[], isForCustomer: boolean, reportName: string) => () => Promise<void>;
	instanceCount: number;
	showFieldReportTypeModal: boolean;
	closeFieldReportTypeModal: () => void;
	closeImagePreviewModal: () => void;
	segmentCountMap: SegmentCount;
	currentlyPreviewedImage: Nullable<string>;
};

const FieldReportTypeSidePanelHeader: React.FC<Props> = ({
	headerValue,
	openFieldReportTypeModal,
	fieldReportTypeToPreview,
	onImageClick,
	onExportAsPDFClick,
	instanceCount,
	closeFieldReportTypeModal,
	closeImagePreviewModal,
	showFieldReportTypeModal,
	segmentCountMap,
	currentlyPreviewedImage,
}) => {

	return (
		<>
			<span className={styles['side-panel-header']}>
				<span className="icon-fullscreen_enter" onClick={openFieldReportTypeModal} />
				{headerValue}
			</span>
			{fieldReportTypeToPreview && (
				<FieldReportTypeSidePanelModal
					closeModal={closeFieldReportTypeModal}
					currentFieldReportType={fieldReportTypeToPreview}
					fieldReportTypeTitle={headerValue}
					instanceCount={instanceCount}
					onExportAsPDFClick={onExportAsPDFClick}
					onImageClick={onImageClick}
					segmentCountMap={segmentCountMap}
					showModal={showFieldReportTypeModal}
				/>
			)}
			{currentlyPreviewedImage && (
				<ImagePreviewModal
					closeModal={closeImagePreviewModal}
					imageSrc={currentlyPreviewedImage}
					showModal={!!currentlyPreviewedImage}
				/>
			)}
		</>
	);
};

export default React.memo(FieldReportTypeSidePanelHeader);

